import React, { useState,lazy, Suspense } from "react";
import { Tabs, Tab, Container, Row, Col } from "react-bootstrap";
import "../assets/css/Recruiter.css";
import { Header, Footer } from "./Container";
import Clients from "./features/recruiter/Clients";
import { UseIcon } from "./hooks/UseIcon";
import JobOpportunities from "./features/recruiter/JobOpportunities";
const AddNewClient = lazy(()=>import("./features/recruiter/AddNewClient"));
const JobSearch = lazy(()=>import("./features/recruiter/JobSearch"));


function Recruiter() {
  const [key, setKey] = useState("clients");
  const [addNewClient, setAddNewClient] = useState(false);

  const _handleAddNewClient = () => {
    setAddNewClient(!addNewClient);
  };
  return (
    <Container fluid="true">
      <Header type="recruiter" />
      <Suspense fallback={<div className="lds-ring"><div></div><div></div><div></div><div></div></div>}>
      <Row className="mt-5 m-0">
        <Col className="p-0">
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={k => setKey(k)}
            className="tabs-custom"
          >
            <Tab 
              className="mr-2 ml-2"
              eventKey="clients"
              title={
                <UseIcon
                  icon={key === "clients" ? "clientsactive" : "clients"}
                  title="Clients"
                  simg="tab-icon"
                />
              }
            >
              {(addNewClient && (
                <AddNewClient _handleAddNewClient={_handleAddNewClient} />
              )) || <Clients _handleAddNewClient={_handleAddNewClient} />}
            </Tab>
            <Tab
              className="mr-2 ml-2"
              eventKey="jobOpportunities"
              title={
                <UseIcon icon={key === "jobOpportunities" ? "jobactive" : "job"}  title="Job Opportunities" simg="tab-icon" />
              }
            >
              <JobOpportunities />
            </Tab>
            <Tab
              className="mr-2 ml-2"
              eventKey="jobSearch"
              title={
                <UseIcon icon="search" title="Job Search" simg="tab-icon" />
              }
            >
              <JobSearch />
            </Tab>
          </Tabs>
        </Col>
      </Row>
      <Footer />
      </Suspense>
    </Container>
  );
}

export default Recruiter;
